import { TagData, Company } from '../../types/tag-data';

export interface ReadTagsResponse {
  success: boolean;
  data: Array<TagItem>;
  total: number;
}

export interface GetTagByIdResponse {
  success: boolean;
  data: TagData;
}

export interface CreateTagsResponse {
  success: boolean;
}

export interface TagItem {
  _id: string;
  name: string;
  type: number;
  description: string;
  company: Company;
  created: string;
  lastModified?: string;
}

export enum TagsMethods {
  READ_RECORDS = 'readRecords',
  CREATE_RECORDS = 'createRecords',
  REMOVE_RECORDS = 'removeRecords',
  REMOVE_BY_FILTER = 'removeByFilter',
  UPDATE_RECORDS = 'updateRecords',
  GET_RECORD = 'getTagById',
  GET_RECORD_FOR_CLONE = 'getTagByIdForClone',
}
